'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of create plan template web
 */ const CreatePlanTemplateWeb = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "19.9609",
                y: "31.625",
                width: "63.9459",
                height: "37.2432",
                rx: "3.47361",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                opacity: "0.7",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.9609 62.1157V65.3861C19.9609 67.3045 21.5161 68.8597 23.4345 68.8597H80.4333C82.3517 68.8597 83.9069 67.3045 83.9069 65.3861V62.1157H19.9609Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.1641",
                y: "68.8633",
                width: "19.6757",
                height: "6.04324",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.2812",
                y: "74.7676",
                width: "33.3081",
                height: "1.68649",
                rx: "0.843243",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "28",
                y: "41",
                width: "15",
                height: "13",
                rx: "0.72807",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "46",
                y: "41",
                width: "15",
                height: "13",
                rx: "0.72807",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "64",
                y: "41",
                width: "15",
                height: "13",
                rx: "0.72807",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M50.4947 46.6285V45.7523H55.4947V50.5665C55.4947 50.8155 55.2632 51 55 51H51C50.7158 51 50.5053 50.8063 50.5053 50.5665V49.6904H52.3789C52.4421 49.6904 52.5053 49.6535 52.5053 49.5797V49.3584C52.5053 49.303 52.4421 49.2477 52.3789 49.2477H50.4947V48.3715H52.3684C52.4316 48.3715 52.4947 48.3347 52.4947 48.2609V48.0395C52.4947 47.9842 52.4316 47.9289 52.3684 47.9289H50.4947V47.0527H52.3684C52.4316 47.0527 52.4947 47.0158 52.4947 46.942V46.7207C52.4947 46.6653 52.4316 46.61 52.3684 46.61H50.4947V46.6285ZM55.6211 44C55.8211 44 56 44.1476 56 44.332V44.9868C56 45.1805 55.8316 45.3188 55.6211 45.3188H50.3789C50.1579 45.3188 50 45.1805 50 44.9868V44.332C50 44.1568 50.1579 44 50.3789 44H55.6316H55.6211Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_3459_3235)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M35.1916 46.0171C35.3294 45.2974 35.747 44.7926 35.9803 44.5614C36.0958 44.4474 36.0314 44.2546 35.8684 44.2253C35.8593 44.2238 35.8499 44.2219 35.8405 44.2207C35.5698 44.1793 35.2992 44.3047 35.1487 44.5245C34.8479 44.9646 34.7913 45.5918 34.7925 46.0096C34.3525 45.7977 33.2951 45.4306 32.5005 46.3157C31.4729 47.4601 32.2389 49.8584 32.9169 50.6158C33.5697 51.3454 34.9999 50.8149 34.9999 50.8149C34.9999 50.8149 36.4297 51.3454 37.0829 50.6158C37.7612 49.858 38.5268 47.4597 37.4993 46.3157C36.6948 45.4197 35.6213 45.8063 35.1916 46.0171Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M34.3021 45.5394C34.4439 45.5737 34.5798 45.4682 34.5743 45.3278C34.5645 45.091 34.5071 44.7364 34.2765 44.4643C34.046 44.1921 33.696 44.0649 33.456 44.0065C33.3138 43.9723 33.1779 44.0777 33.1838 44.2181C33.1936 44.4549 33.2509 44.8095 33.4815 45.082C33.7117 45.3542 34.0621 45.4814 34.3017 45.5394H34.3021Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M72.2724 46.7397H75V48.2845H72.2724V51H70.7276V48.2845H68V46.7397H70.7276V44H72.2724V46.7397Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3459_3235",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "6",
                        height: "7",
                        fill: "white",
                        transform: "translate(32 44)"
                    })
                })
            })
        ]
    });
};

exports.CreatePlanTemplateWeb = CreatePlanTemplateWeb;
//# sourceMappingURL=CreatePlanTemplateWeb.cjs.map
